import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { CONFIG_STUDIO_API } from "./apiRoutes";

interface UseGetConfigProps {
  communityId: string;
  documentTypeId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getConfig = async (communityId: string, documentTypeId: string) =>
  await axiosAuth.get(`${CONFIG_STUDIO_API}/config/${communityId}/${documentTypeId}`);

const useGetConfig = ({
  communityId,
  documentTypeId,
  queryParams,
}: UseGetConfigProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["gl-config", communityId, documentTypeId],
    queryFn: () => getConfig(communityId, documentTypeId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetConfig;
